import { render, staticRenderFns } from "./PurchaseOrderListSideMenu.vue?vue&type=template&id=93116598"
import script from "./PurchaseOrderListSideMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports